import gsap from "gsap";
import barba from '@barba/core';
import ScrollTrigger from "gsap/ScrollTrigger";

export default class{

	constructor(){
        gsap.registerPlugin(ScrollTrigger);
        this.addEvented = false
        barba.hooks.once((data) => {
            this.init(document)
        });
        barba.hooks.after((data) => {
            setTimeout(() => {
                this.init(data.next.container)
            }, 1000);
        });
    }

    init(d){
        const imgExtensions = d.querySelectorAll("[data-img-animation]");
        if(imgExtensions.length > 0){
            imgExtensions.forEach( imgExtension => {
                const extentionBg = imgExtension.querySelectorAll('.js-extention-bg')
                const extentionImg = imgExtension.querySelectorAll('.js-extention-img')
                const custom_anime = gsap.timeline({
                    scrollTrigger: {
                      trigger: imgExtension, 
                      start: "top center",
                    //   markers: true
                    }
                });
                custom_anime.to(extentionBg, {
                    borderRadius:"0px", 
                    duration: 1, 
                });
                custom_anime.to(extentionImg, {
                    opacity: 1,
                    scale: 1,
                    duration: 1, 
                },"-=0.3");
            })
        }
    }
}